export interface WorldpayRedirectResponse {
  clientReferenceNumber: string;
  orderNumber: string;
  status: string;
  url: string;
}
